import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useSession } from '@sentinel/auth-core';

function PortalIndex() {
  const { user, loading } = useSession();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    void navigate({ to: user ? '/account' : '/login', replace: true });
  }, [user, loading, navigate]);

  return null;
}

export const Route = createFileRoute('/')({ component: PortalIndex });
